import React, { useEffect } from "react";
import { zodResolver } from "@hookform/resolvers/zod";
import MainContainer from "../../components/container/MainContainer";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import ResourseButtons from "../../components/form/buttons/ResourseButtons";
import {
  getAccount,
  getExpenditureAccountByTerm,
  getIncomeAccountByTerm,
  unsetAllAccounts,
} from "../../features/accountsSlice";
import {
  addTransaction,
  getMethodTypes,
} from "../../features/transactionsSlice";
import { useDispatch, useSelector } from "react-redux";
import { getCurrencies } from "../../features/currenciesSlice";
import { useNotification } from "../../components/notification/NotificationContainer";
import InputField2 from "../../components/form/InputField2";
import AsyncSelectInput2 from "../../components/form/AsyncSelectInput2";
import SelectField2 from "../../components/form/SelectField2";
import {
  getActiveProjectsByTerm,
  unsetProjects,
} from "../../features/projectsSlice";
import { addReceiptTransactionSchema } from "../../schemas";
import { useState } from "react";
import { useCallback } from "react";
import TextContainer from "../../components/text/TextContainer";

const ReceiptTransaction = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.userInfo);
  const methodTypes = useSelector((state) => state.transactions.methodTypes);
  const loading = useSelector(
    (state) => state.transactions.load.addTransaction
  );
  const currencies = useSelector((state) => state.currencies.data);
  const { pathname } = useLocation();
  const addNotification = useNotification();
  let path = "Cash";
  const [incomeAcctts, setIncomeAccts] = useState({});
  const [expAccts, setExpAccts] = useState({});

  const {
    handleSubmit,
    register,
    setValue,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: { exchange_rate: 1.0 },
    resolver: zodResolver(addReceiptTransactionSchema),
  });

  //
  const watchIncAcc = watch("receiver_id");
  const watchExpAcc = watch("sender_id");
  const watchExchange = watch("exchange_rate");

  //Get Income Account Details
  const getIncAcc = useCallback(async () => {
    try {
      if (!watchIncAcc) {
        setIncomeAccts({});
      } else {
        const res = await dispatch(getAccount(watchIncAcc));
        if (getAccount.fulfilled.match(res)) {
          setIncomeAccts(res.payload);
        }
      }
    } catch (error) {}
  }, [watchIncAcc]);

  //Get Expenditure Account Details
  const getExpAcc = useCallback(async () => {
    try {
      if (!watchExpAcc) {
        setExpAccts({});
      } else {
        const res = await dispatch(getAccount(watchExpAcc));
        if (getAccount.fulfilled.match(res)) {
          setExpAccts(res.payload);
        }
      }
    } catch (error) {}
  }, [watchExpAcc]);

  const onSubmit = async (data, e) => {
    try {
      e.preventDefault();
      let newData = {
        province_id: user.province_id,
        user_id: user.id,
        method_id: data.method_id,
        currency_id: data.currency_id,
        project_id: data.project_id,
        exchange_rate: data.exchange_rate,
        date: data.date,
        naration: data.naration,
        entries: [
          {
            account_id: data.sender_id,
            type: "credit",
            amount: data.amount,
          },
          {
            account_id: data.receiver_id,
            type: "debit",
            amount: data.amount * data.exchange_rate,
          },
        ],
        transactionDetails: [],
      };

      if (data.cheque_number) {
        newData.transactionDetails.push({
          name: "cheque_number",
          value: data.cheque_number,
        });
      }

      const res = await dispatch(addTransaction(newData));
      if (addTransaction.fulfilled.match(res)) {
        addNotification(res.payload.message, "success");
        navigate("/accounts/transaction");
      } else {
        addNotification(res.payload.message, "error");
      }
    } catch (error) {
      addNotification(error.message, "warning");
    }
  };
  //Check start path
  useEffect(() => {
    dispatch(getMethodTypes());
    dispatch(getCurrencies());
    return () => {
      dispatch(unsetProjects());
      dispatch(unsetAllAccounts());
    };
  }, []);

  //Income
  useEffect(() => {
    getIncAcc();
  }, [watchIncAcc]);

  //Expenditure
  useEffect(() => {
    getExpAcc();
  }, [watchExpAcc]);

  useEffect(() => {
    if (
      expAccts.id &&
      incomeAcctts.id &&
      expAccts.currency === incomeAcctts.currency
    ) {
      // reset({ exchange_rate: 1 });
      setValue("exchange_rate", 1);
    } else {
    }
  }, [expAccts, incomeAcctts, setValue, watchExchange]);

  //Check path End

  return (
    <MainContainer className="bg-content pb-10">
      <div className="text-text-1">
        <div className="sm:px-10 lg:px-20 xl:px-40 2xl:px-60">
          <h3 className="text-text-1/80 mb-5">Receipt </h3>
        </div>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="sm:px-10 lg:px-20 xl:px-40 2xl:px-60">
            <div className="flex items-center justify-between gap-2 md:gap-20 flex-col md:flex-row">
              <SelectField2
                register={register}
                name="method_id"
                label="Type"
                labelWidth="w-48"
                errors={errors.method_id}
                data={[{ id: null, name: "-- Select Type" }, ...methodTypes]}
              />
              <SelectField2
                register={register}
                name="currency_id"
                label="Currency"
                labelWidth="w-48"
                errors={errors.currency_id}
                data={[{ id: null, name: "-- Select Currency" }, ...currencies]}
              />
            </div>

            <div className="flex items-center justify-between gap-2 md:gap-20 flex-col md:flex-row">
              <InputField2
                name="date"
                label="Date"
                labelWidth="w-48"
                errors={errors.date}
                type="date"
                defaultValue={new Date().toISOString().split("T")[0]}
                register={register}
              />
              <InputField2
                register={register}
                name="exchange_rate"
                label="Exchange Rate"
                labelWidth="w-48"
                type="number"
                valueAsNumber
                disabled={
                  expAccts &&
                  incomeAcctts &&
                  expAccts.currency === incomeAcctts.currency
                }
                errors={errors.exchange_rate}
              />
            </div>

            <div className="flex items-start justify-between gap-2 md:gap-20 flex-col md:flex-row">
              {expAccts.id && (
                <div className="border border-bkg2 rounded-md bg-bkg2 px-3 py-2 w-auto  flex flex-col sm:flex-row mb-2 gap-2 sm:gap-10">
                  <>
                    <div>
                      <TextContainer
                        label="Currency"
                        content={expAccts.currency}
                      />
                    </div>
                    <div>
                      <TextContainer
                        label="Balance"
                        content={`${expAccts.symbol} ${expAccts.balance}`}
                      />
                    </div>
                  </>
                </div>
              )}
            </div>

            <div className="flex items-center justify-between gap-10 sm:gap-20">
              <AsyncSelectInput2
                name="sender_id"
                label="From Account"
                labelWidth="w-40"
                register={register}
                setValue={setValue}
                fetchOptions={getIncomeAccountByTerm}
                errors={errors.sender_id}
              />
              {/* Cheque Section Start */}
              {/* Cheque Section End */}
            </div>
            <div className="flex items-start justify-between gap-2 md:gap-20 flex-col md:flex-row">
              {incomeAcctts.id && (
                <div className="border border-bkg2 rounded-md bg-bkg2 px-3 py-2 w-auto  flex flex-col sm:flex-row mb-2 gap-2 sm:gap-10">
                  <>
                    <div>
                      <TextContainer
                        label="Currency"
                        content={incomeAcctts.currency}
                      />
                    </div>
                    <div>
                      <TextContainer
                        label="Balance"
                        content={`${incomeAcctts.symbol} ${incomeAcctts.balance}`}
                      />
                    </div>
                  </>
                </div>
              )}
            </div>
            <div className="flex items-center justify-between gap-10 sm:gap-20">
              <AsyncSelectInput2
                name="receiver_id"
                register={register}
                setValue={setValue}
                label="To Account"
                labelWidth="w-40"
                fetchOptions={getExpenditureAccountByTerm}
                errors={errors.receiver_id}
              />
            </div>
            <div className="flex items-center justify-between gap-10 sm:gap-20">
              <AsyncSelectInput2
                name="project_id"
                label="Project"
                labelWidth="w-40"
                register={register}
                setValue={setValue}
                fetchOptions={getActiveProjectsByTerm}
                errors={errors.project_id}
              />
              {/* Cheque Section Start */}
              {/* Cheque Section End */}
            </div>
            <div className="flex items-center justify-between gap-10 sm:gap-20">
              <InputField2
                name="amount"
                label="Amount"
                labelWidth="w-40"
                placeholder="Amount"
                valueAsNumber
                errors={errors.amount}
                register={register}
                type="number"
              />
            </div>

            {/* <div className="mt-3 border border-bkg2 pt-3 px-2">
              <div className="flex justify-evenly items-end gap-10 sm:gap-20">
                <div className=""></div>
              </div>
            </div> */}

            <InputField2
              name="naration"
              label="Naration"
              labelWidth="w-40"
              errors={errors.naration}
              type="text"
              autoComplete="off"
              register={register}
            />
            <ResourseButtons
              link
              loading={loading}
              text="Back"
              to="/accounts/transaction"
            />
          </div>
        </form>
      </div>
    </MainContainer>
  );
};

export default ReceiptTransaction;
